import { useOptimizely } from '@libs/common-next';

import { usePurchaseFormValue } from '@/entities/purchase-form';

export const useTrackEventAddToCart = () => {
    const { context } = useOptimizely();

    const getValues = usePurchaseFormValue();

    const trackEvent = () => {
        const { fulfilmentMethod, purchaseOption } = getValues();
        const purchaseAbbreviation = purchaseOption == 'autoship' ? 'AS' : 'OT';
        context?.trackEvent(`${purchaseAbbreviation}_${fulfilmentMethod?.toUpperCase()}_ATC`);
    };

    return { trackEvent };
};
